import React from "react";

const ReportsInsights = () => {
  return (
    <div>
      <h1>Reports & Insights</h1>
      <p>Generate reports and view detailed insights about your platform.</p>
    </div>
  );
};

export default ReportsInsights;
